const ResourceQuery = () =>
  import('@/views/main/wechatMgmt/resourceQuery/ResourceQuery.vue')

export default {
  path: '/main/wechatMgmt/resourceQuery',
  name: 'ResourceQuery',
  component: ResourceQuery
}
